export const languageList = [
    {
        "key": "csharp",
        "label": "C#",
        "syntax_mode": "csharp",
        "variants": [
            {
                "key": "RestSharp"
            }
        ]
    },
    {
        "key": "curl",
        "label": "cURL",
        "syntax_mode": "powershell",
        "variants": [
            {
                "key": "cURL"
            }
        ]
    },
    {
        "key": "dart",
        "label": "Dart",
        "syntax_mode": "dart",
        "variants": [
            {
                "key": "http"
            }
        ]
    },
    {
        "key": "go",
        "label": "Go",
        "syntax_mode": "golang",
        "variants": [
            {
                "key": "Native"
            }
        ]
    },
    {
        "key": "http",
        "label": "HTTP",
        "syntax_mode": "text",
        "variants": [
            {
                "key": "HTTP"
            }
        ]
    },
    {
        "key": "java",
        "label": "Java",
        "syntax_mode": "java",
        "variants": [
            {
                "key": "OkHttp"
            },
            {
                "key": "Unirest"
            }
        ]
    },
    {
        "key": "javascript",
        "label": "JavaScript",
        "syntax_mode": "javascript",
        "variants": [
            {
                "key": "Fetch"
            },
            {
                "key": "jQuery"
            },
            {
                "key": "XHR"
            }
        ]
    },
    {
        "key": "c",
        "label": "C",
        "syntax_mode": "c_cpp",
        "variants": [
            {
                "key": "libcurl"
            }
        ]
    },
    {
        "key": "nodejs",
        "label": "NodeJs",
        "syntax_mode": "javascript",
        "variants": [
            {
                "key": "Axios"
            },
            {
                "key": "Native"
            },
            {
                "key": "Request"
            },
            {
                "key": "Unirest"
            }
        ]
    },
    {
        "key": "objective-c",
        "label": "Objective-C",
        "syntax_mode": "objectivec",
        "variants": [
            {
                "key": "NSURLSession"
            }
        ]
    },
    {
        "key": "ocaml",
        "label": "OCaml",
        "syntax_mode": "ocaml",
        "variants": [
            {
                "key": "Cohttp"
            }
        ]
    },
    {
        "key": "php",
        "label": "PHP",
        "syntax_mode": "php",
        "variants": [
            {
                "key": "cURL"
            },
            {
                "key": "Guzzle"
            },
            {
                "key": "HTTP_Request2"
            },
            {
                "key": "pecl_http"
            }
        ]
    },
    {
        "key": "powershell",
        "label": "PowerShell",
        "syntax_mode": "powershell",
        "variants": [
            {
                "key": "RestMethod"
            }
        ]
    },
    {
        "key": "python",
        "label": "Python",
        "syntax_mode": "python",
        "variants": [
            {
                "key": "http.client"
            },
            {
                "key": "Requests"
            }
        ]
    },
    {
        "key": "r",
        "label": "R",
        "syntax_mode": "r",
        "variants": [
            {
                "key": "httr"
            },
            {
                "key": "RCurl"
            }
        ]
    },
    {
        "key": "ruby",
        "label": "Ruby",
        "syntax_mode": "ruby",
        "variants": [
            {
                "key": "Net::HTTP"
            }
        ]
    },
    {
        "key": "shell",
        "label": "Shell",
        "syntax_mode": "powershell",
        "variants": [
            {
                "key": "Httpie"
            },
            {
                "key": "wget"
            }
        ]
    },
    {
        "key": "swift",
        "label": "Swift",
        "syntax_mode": "swift",
        "variants": [
            {
                "key": "URLSession"
            }
        ]
    }
]
